"use client";
import dynamic from "next/dynamic";
import { useLazyLoad, LAZY_LOAD_CONFIGS } from "@hooks/useLazyLoad";
import styles from "./MMGallery.module.scss";

const GallerySkeleton = () => (
  <div className={styles["mm-gallery__wrapper"]}>
    <div className={styles["mm-gallery"]}>
      <div className={styles["mm-gallery__titleSkeleton"]} />
      <div className={styles["mm-gallery__imagesSkeleton"]}>
        {Array.from({ length: 5 }).map((_, index) => (
          <div
            key={index}
            className={styles["mm-gallery__imageSkeleton"]}
          />
        ))}
      </div>
    </div>
  </div>
);

const MMGallery = dynamic(
  () => import("./index").then((mod) => mod.MMGallery),
  {
    ssr: false,
    loading: () => <GallerySkeleton />,
  }
);

export default function MMGalleryClient(props: any) {
  const shouldLoad = useLazyLoad(LAZY_LOAD_CONFIGS.GALLERY);

  if (!shouldLoad) {
    return <GallerySkeleton />;
  }

  return <MMGallery {...props} />;
}
